const RestrictedView = () => (
    <div className="p-5 text-white bg-danger rounded-3">
        You do not have access on this app. If you believe this is a mistake, contact your administrator.
    </div>
);

export { RestrictedView };
